import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import {
  DefaultReportV2CostOfGoodsSoldQuery,
  DefaultReportV2ListingQuery,
  DefaultReportV2PurchaseOrderLineItemQuery,
  DefaultReportV2PurchaseQuery,
  DefaultReportV2SaleCostAdjustmentsQuery,
  DefaultReportV2SaleLineItemQuery,
  DefaultReportV2SaleQuery,
  DefaultReportV2SoldTicketQuery,
  DefaultReportV2TicketGroupQuery,
  EmptyCommissionQuery,
} from 'src/utils/eventQueryUtils';
import { ReportTypesV2 } from 'src/utils/reportsUtils';

export const REPORT_TYPE_TO_DEFAULT_FILTER_QUERY: Record<
  ReportTypesV2,
  ReportConfigV2['request']['filters']
> = {
  [ReportTypesV2.InventoryV2]: DefaultReportV2ListingQuery,
  [ReportTypesV2.SaleLineItem]: DefaultReportV2SaleLineItemQuery,
  [ReportTypesV2.PurchaseOrderLineItem]:
    DefaultReportV2PurchaseOrderLineItemQuery,
  [ReportTypesV2.SoldTicket]: DefaultReportV2SoldTicketQuery,
  [ReportTypesV2.Purchase]: DefaultReportV2PurchaseQuery,
  [ReportTypesV2.SaleV2]: DefaultReportV2SaleQuery,
  [ReportTypesV2.Commission]: EmptyCommissionQuery,
  [ReportTypesV2.CostOfGoodsSold]: DefaultReportV2CostOfGoodsSoldQuery,
  [ReportTypesV2.SaleCostAdjustments]: DefaultReportV2SaleCostAdjustmentsQuery,
  [ReportTypesV2.TicketGroup]: DefaultReportV2TicketGroupQuery,
};
